import styled, {css} from 'styled-components';

const WeekDaysWrapper = styled.div`
	width: 100%;
	display: flex;
	align-items: flex-start;
	gap: 4px;
`;

const WeekDayContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 48px;
	height: 48px;
`;

const WeekDayLabel = styled.span`
	font-size: 16px;
	font-weight: 400;
	line-height: 29.88px;
	letter-spacing: 0.4px;
	${({theme}) => css`
		color: ${theme.colors.light.text.primary};
	`}
`;

export {WeekDaysWrapper, WeekDayContent, WeekDayLabel};
